export type Integration = {
  androidUseOsNotifications?: boolean;
  arn?: string;
  authType?: IntegrationAuthType;
  bundleID?: string;
  certificate?: string;
  deviceCount?: number;
  keyID?: string;
  mobileAppId?: number;
  mobileAppName?: string;
  name: string;
  /** ONLY used when updating androidUseOsNotifications param */
  newUseOsNotificationsValue?: boolean;
  notValidAfter?: number;
  notValidBefore?: number;
  p12password?: string;
  p12file?: File;
  p8File?: File;
  platform: IntegrationPlatform;
  privateKey?: string;
  projectId?: number;
  teamID?: string;
  testPushSuccess?: boolean;
};

export type MobileApp = {
  id: number;
  name: string;
  packageName: string;
  platform: AppPlatform;
  projectId?: number;
  storeUrl: string;
};

export enum IntegrationPlatform {
  GCM = 'GCM',
  APNS = 'APNS',
  APNS_SANDBOX = 'APNS_SANDBOX',
}

export enum AppPlatform {
  ANDROID = 'Android',
  IOS = 'iOS',
  OTT = 'OTT',
  WEB = 'Web',
}

export enum IntegrationAuthType {
  P8 = 'p8AuthKey',
  P12 = 'p12Certificate',
  PEM = 'pemCertificate',
  FIREBASE = 'firebase',
  FIREBASE_JSON = 'firebaseJson',
}

export enum IntegrationModalView {
  AUTH_SELECT,
  AUTH_DETAILS,
}

export enum IntegrationModalId {
  UPDATE = 'update-integration-modal-id',
  DELETE = 'delete-integration-modal-id',
  TEST_PUSH = 'test-push-modal-id',
}

export type IntegrationType = {
  [IntegrationPlatform.GCM]?: Integration[];
  [IntegrationPlatform.APNS]?: Integration[];
  [IntegrationPlatform.APNS_SANDBOX]?: Integration[];
};

export type IntegrationsById = {
  [key: string]: IntegrationType;
};

export type UnassignedIntegrations = {
  unassigned: Integration[];
};

export type IntegrationTableRow = {
  'data-test': string;
  id: string;
  authType?: IntegrationAuthType;
  authTypeLabel: string;
  environment: string;
  integrationName: string;
  osNotification: string;
  devices: number | 'N/A';
  status: JSX.Element;
  actions: JSX.Element;
};

export type IntegrationStatusBadge = Record<'ACTIVE' | 'EXPIRED' | 'TEST_PUSH', JSX.Element>;

export type IntegrationOption = {
  name: string;
  type: IntegrationPlatform;
  value?: string;
};

export type IntegrationFormOption = {
  id: IntegrationAuthType;
  name: string;
  value: IntegrationAuthType;
  description: string;
};

export type P12FormData = {
  p12file: string;
  p12password: string;
};

export type P8FormData = {
  p8File: string;
  keyID: string;
  teamID: string;
  bundleID: string;
};

export type TestPushPayload = {
  deviceToken: string;
  message: string;
  pushConfig: Integration;
};

export type MobileAppsReducerState = {
  apps: Record<string, MobileApp>;
  integrations: IntegrationsById & UnassignedIntegrations;
  integrationsLoadingState: boolean;
  isFetchingMobileApps: boolean;
  isFetchingIntegrations: boolean;
  fetchingMobileAppsError: boolean;
  fetchingIntegrationsError: boolean;
  createOrUpdateIntegrationInProgress: boolean;
  createOrUpdateIntegrationError: boolean;
};
